import React from 'react'

// utils
import { createOrder } from './PurchaseOrderHeader.utils'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_NUMBER_AND_STATUS } from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'

// components
import ActionButton from '../../../../components/buttons/ActionButton/ActionButton.component'

// mui
import { Grid, Container, Typography } from '@mui/material'

export default function PurchaseOrderHeader({ id, editClickHandler, receiveClickHandler }) {

    let order = {}

    const { loading, error, data } = useQuery(GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_NUMBER_AND_STATUS, {
        variables: { id }
    })

    if(data && data.equipmentPurchaseOrder) {
        order = createOrder(data.equipmentPurchaseOrder)
    }

    return (<div>
        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}><Typography variant="h2">{`P.O. #${order.number}`}</Typography></Grid>
            
                <Grid item xs={6} container spacing={2} justifyContent='flex-end'>
                    {
                        order.isOutstanding && <Grid item><ActionButton label="Receive Equipment" color="secondary" onClick={receiveClickHandler} /></Grid>
                    }
                    <Grid item>
                        <ActionButton label="Edit" onClick={editClickHandler} />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </div>)
}